<template>
  <el-row type="flex" class="web-wrapper">
    <el-header>
      <h3 class="title">
        <div class="block">
          <span>H5接入</span>
        </div>
      </h3>
    </el-header>
    <el-row type="flex" class="webhfive-addbox">
      <div class="webhfive-addbox-left">
        <el-scrollbar class="scrollbar-wrap">
          <div class="webhfive-addbox-con" id="webhfive-addbox-scroll">
            <div class="webhfive-addbox-title">
              <i></i>
              <span>网站接入基本配置</span>
            </div>
            <div class="webhfive-addbox-box">
              <el-form size="medium" label-width="160px" ref="configForm1" :model="configForm1" :rules="rules">
                <el-form-item label="H5名称" prop="name">
                  <el-input v-model="configForm1.name" placeholder="请输入网站名称" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="H5域名" prop="webDomainName">
                  <el-input v-model="configForm1.webDomainName" placeholder="请输入网站域名" maxlength="60" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="启用智能机器人">
                  <el-radio-group v-model="configForm1.useRobot">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="欢迎语" prop="greeting">
                  <el-input type="textarea" v-model="configForm1.greeting" placeholder="请输入欢迎语，不超过240个字" maxlength="240"></el-input>
                </el-form-item>
                <el-form-item label="路由策略" prop="routeStrategy">
                  <el-select v-model="configForm1.routeStrategy" placeholder="请选择">
                    <el-option v-for="strategy in routeStrategyList" :key="strategy.id" :label="strategy.acdName" :value="strategy.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="webhfive-addbox-title" v-if="configForm1.useRobot">
              <i></i>
              <span>智能机器人配置</span>
            </div>
            <div class="webhfive-addbox-box" v-if="configForm1.useRobot">
              <el-form size="medium" label-width="160px" status-icon ref="configForm2" :model="configForm2" :rules="rules">
                <el-form-item label="机器人服务地址" prop="robotServiceAddress">
                  <el-input v-model="configForm2.robotServiceAddress" placeholder="请输入机器人服务地址" maxlength="200" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="机器人通讯地址" prop="robotSocketAddress">
                  <el-input v-model="configForm2.robotSocketAddress" placeholder="请输入机器人通讯地址" maxlength="200" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="机器人维度参数" prop="robotDimParam">
                  <div v-for="(item, index ) in configForm2.robotDimParam" :key="index">
                    <el-input v-model="item.dimKey" placeholder="请输入维度ID" :disabled="index === 0" style="width: 35%; margin-bottom: 5px;"></el-input>
                    <el-input v-model="item.tagId" placeholder="请输入TagID" style="width: 35%; margin-bottom: 5px;"></el-input>
                    <el-button type="text" v-if="index !== 0" @click="deleteRobotDimParam(index)">
                      <svg class="icon icon-delete" aria-hidden="true">
                        <use xlink:href="#iconchahao" />
                      </svg>
                    </el-button>
                  </div>
                  <div v-if="configForm2.robotDimParam.length < 5">
                    <el-row>
                      <el-col :span="5">
                        <el-button type="primary" @click="addRobotDimParam()">
                          <svg class="icon icon-bianji" aria-hidden="true">
                            <use xlink:href="#iconzengjia" />
                          </svg>
                        </el-button>
                      </el-col>
                      <el-col :span="2" :offset="2">
                        <el-button type="text">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#iconheadicon-help" />
                          </svg>
                        </el-button>
                      </el-col>
                      <el-col :span="15" style="line-height: 20px;">
                        <span>1.可添加多个渠道维度参数</span>
                        <p />
                        <span>2.相同维度只能添加一个参数</span>
                      </el-col>
                    </el-row>
                  </div>
                  <span v-if="configForm2RepetList.length > 0" style="color: red;">警告：存在重复维度参数设置！</span>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-scrollbar>
        <el-row class="webhfive-addbox-btnbox" type="flex" justify="center">
          <el-button size="medium" @click="goBack">返 回</el-button>
          <el-button type="primary" size="medium" @click="saveConfig" :loading="btnLoading">保存设置</el-button>
        </el-row>
      </div>
    </el-row>
  </el-row>
</template>

<script>
import { getWebStrategies } from '@/api/channel/web.js'
import { saveH5Configs, getH5ConfigsById } from '@/api/channel/h5.js'

export default {
  name: 'h5Deploy',
  data() {
    var robotDimParamValidate = (rule, value, callback) => {
      this.configForm2RepetList = []
      if (value.length > 0) {
        var keyList = []
        value.forEach(item => {
          const key = item.dimKey.trim()
          if (keyList.includes(key)) {
            this.configForm2RepetList.push(key)
          } else {
            keyList.push(key)
          }
        })
      }
      callback()
    }
    return {
      btnLoading: false,
      // 一、配置表单
      // --(1)网站接入基本配置
      configForm1: {
        platformId: 'h5', // 固定值,不需要改动
        id: '',
        name: '',
        webDomainName: '',
        useRobot: false,
        greeting: '',
        routeStrategy: ''
      },
      // 智能机器人配置
      configForm2: {
        robotServiceAddress: '',
        robotSocketAddress: '',
        robotDimParam: [
          { dimKey: 'platform', tagId: 'web' }
        ]
      },
      configForm2RepetList: [],
      // 路由策略下拉框数据(来自后端接口)
      routeStrategyList: [],
      // 表单校验规则
      rules: {
        name: [
          { required: true, message: '请输入网站名称', trigger: 'blur' }
        ],
        webDomainName: [
          { required: true, message: '请输入网站域名', trigger: 'blur' }
        ],
        greeting: [
          { required: true, message: '请输入欢迎语', trigger: 'blur' }
        ],
        routeStrategy: [
          { required: true, message: '请输入路由策略', trigger: 'change' }
        ],
        robotServiceAddress: [
          { required: true, message: '请输入机器人服务地址', trigger: 'blur' }
        ],
        robotSocketAddress: [
          { required: true, message: '请输入机器人通讯地址', trigger: 'blur' }
        ],
        robotDimParam: [
          { validator: robotDimParamValidate, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    // 加载路由策略下拉框
    this.getWebStrategiesList()
    if (this.$parent.currentChannelInfoId) {
      this.getConfig()
    }
  },
  computed: {
  },
  methods: {
    // 获取路由策略下拉框数据
    getWebStrategiesList() {
      getWebStrategies().then(res => {
        if (res.data && res.data.length > 0) {
          this.routeStrategyList = res.data
        }
      })
    },
    // 初始化数据
    getConfig() {
      getH5ConfigsById({ id: this.$parent.currentChannelInfoId }).then(res => {
        const configForm1 = {}
        configForm1.id = res.id
        configForm1.platformId = res.platformId
        configForm1.name = res.name
        configForm1.webDomainName = res.webDomainName
        configForm1.useRobot = res.useRobot
        configForm1.greeting = res.greeting
        configForm1.routeStrategy = res.routeStrategy
        this.configForm1 = configForm1
        const configForm2 = {}
        configForm2.robotServiceAddress = res.robotServiceAddress
        configForm2.robotSocketAddress = res.robotSocketAddress
        const robotDimParam = JSON.parse(res.robotDimParam)
        configForm2.robotDimParam = robotDimParam === null ? [{ dimKey: 'platform', tagId: 'web' }] : robotDimParam
        this.configForm2 = configForm2
      })
    },
    // 删除机器人维度参数
    deleteRobotDimParam(index) {
      this.configForm2.robotDimParam.splice(index, 1)
      this.$refs.configForm2.validate()
    },
    // 添加机器人维度参数
    addRobotDimParam() {
      this.configForm2.robotDimParam.push({ dimKey: '', tagId: '' })
    },
    // 返回主页面的方法
    goBack() {
      this.$parent.changeView('H5List')
      this.resetConfig()
    },
    // 重置配置的方法
    resetConfig() {
      this.$parent.currentChannelInfoId = ''
    },
    // 保存设置
    saveConfig() {
      const valid1 = new Promise((resolve, reject) => {
        this.$refs.configForm1.validate(valid => {
          if (valid) {
            resolve()
          }
        })
      })
      var validList
      if (this.configForm1.useRobot) {
        const valid2 = new Promise((resolve, reject) => {
          this.$refs.configForm2.validate(valid => {
            if (valid) {
              resolve()
            }
          })
        })
        validList = [valid1, valid2]
      } else {
        validList = [valid1]
      }
      if (this.configForm1.useRobot) {
        this.configForm2.robotDimParam = this.configForm2.robotDimParam.filter(each => each.dimKey.trim() !== '')
        this.$refs.configForm2.validate()
        if (this.configForm2RepetList.length > 0) {
          this.$message.warning('存在重复的机器人维度设置！')
          return
        }
      }
      Promise.all(validList).then(() => {
        const configs = this.configForm1.useRobot ? { ...this.configForm1, ...this.configForm2 } : this.configForm1
        if (configs.useRobot) {
          configs.robotDimParam = JSON.stringify(configs.robotDimParam)
        }
        this.btnLoading = true
        saveH5Configs(configs).then(res => {
          this.btnLoading = false
          // console.log('save', res)
          if (res.code && res.code === 2000) {
            this.$message.success('保存成功!')
            this.goBack()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(err => {
          this.btnLoading = false
          this.$message.error(err)
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.web-wrapper {
  height: calc(100vh - 76px);
  flex-direction: column;
}
.el-header {
  height: auto !important;
  margin-bottom: 0;
  padding: 0;
  .title {
    margin-bottom: 20px;
  }
}
.webhfive-addbox {
  height: calc(100% - 70px);
  /*width: auto;
  height: auto;
  position: absolute;
  top: 91px;
  bottom: 0;
  left: 0px;
  right: 0;*/
  .webhfive-addbox-title {
    // background-color: #f5f5f5;
    height: 38px;
    line-height: 38px;
    font-size: 16px;
    margin-right: 10px;
    i {
      width: 3px;
      height: 14px;
      border-radius: 1px;
      display: inline-block;
      background-color: #337eff;
      margin: 13px 17px 0 0;
    }
  }

  .webhfive-addbox-left {
    margin: 0 auto; // 布局居中
    position: relative;
    width: 58%;
    height: 100%;
    .scrollbar-wrap {
      height: calc(100% - 70px);
    }
    .webhfive-addbox-con {
      width: auto;
      .webhfive-addbox-box {
        width: 100%;
        padding-top: 20px;
        padding-left: 20px;
        height: auto;
        margin-bottom: 20px;
        &:nth-child(1) {
          margin: 0;
        }

        ::v-deep .el-form-item {
          .el-form-item__error {
            padding-top: 2px;
          }
        }

        .webhfive-addbox-inputbox {
          margin-bottom: 15px;
          width: 100%;
          .webhfive-addbox-span {
            width: 160px;
            line-height: 36px;
            padding-left: 20px;
            font-size: 12px;
            color: #333;
          }

          .tips-wrapper {
            margin: 10px 0 0 10px;
          }
        }

        .icon-addbox {
          width: 18px;
          height: 18px;
          border: 1px solid #cfd5db;
          background-color: #f4f4f5;
          border-radius: 2px;
          text-align: center;
          cursor: pointer;
          &:hover {
            background-color: #409eff;
            border: 1px solid #409eff;
            .icon {
              color: #fff;
            }
          }

          .icon {
            color: #cfd5db;
          }
        }

        .webhfive-addbox-inline {
          width: 210px;
          display: inline-block;
          float: none;
        }

        .webhfive-addbox-center {
          align-self: center;
          margin-left: 10px;
          margin-top: 10px;
        }

        .webhfive-addbox-width {
          width: 100%;
          float: left;
          margin-top: 10px;
          &:nth-child(1) {
            margin: 0;
          }
        }

        .webhfive-addbox-width170 {
          width: 170px;
        }

        .webhfive-addbox-width390 {
          width: 390px;
        }

        .webhfive-addbox-ul {
          display: flex;
          margin-top: 5px;
          li {
            width: 26px;
            height: 26px;
            text-align: center;
            background-color: #e5e5e5;
            border-radius: 2px;
            margin-right: 10px;
            margin-bottom: 5px;
            cursor: pointer;
            border: none;
            .icon {
              vertical-align: inherit;
              font-size: 16px;
              color: #7f7f7f;
            }
            &:hover {
              background-color: #3fbeff;
              .icon {
                color: #fff;
              }
            }
            &.active {
              background-color: #3fbeff;
              .icon {
                color: #fff;
              }
            }
          }
        }
      }
    }

    .webhfive-addbox-btnbox {
      position: absolute;
      z-index: 2;
      bottom: 0;
      left: -20px;
      right: 0;
      border-top: 1px solid #ebebeb;
      background-color: #fff;
      text-align: center;
      padding-top: 15px;
      padding-bottom: 15px;
      box-shadow: 0px -3px 5px rgba(200, 200, 200, 0.4);
    }
  }
}
.el-form {
  /* display: flex;
  align-items: center;
  justify-content: space-between;*/

  .el-form-item {
    margin-bottom: 15px;
    ::v-deep .el-form-item__label {
      font-size: 12px;
      color: #333;
      text-align: left;
    }
    ::v-deep .el-form-item__content {
      .form-item-line {
        display: flex;
        margin-bottom: 12px;
        .el-button {
          margin-left: 10px;
        }
      }

      .el-input,
      .el-textarea,
      .el-select {
        width: 80%;
        margin-right: 10px;
        font-size: 12px;
      }
      .el-select {
        .el-input {
          width: 100%;
        }
      }

      .el-row {
        width: 80%;
        .el-input,
        .el-textarea,
        .el-select {
          width: 100%;
          margin-right: 0;
        }
      }

      .sub-title {
        margin-top: 5px;
        color: #999;
        line-height: 1.4;
      }

      .el-upload {
        margin-top: 3px;
        .el-button {
          padding: 0;
          border: 1px solid transparent;
          background-color: transparent;
          color: #337eff;
          > * {
            display: flex;
            align-items: center;

            .icon {
              font-size: 34px;
              color: #99a3ae;
            }
          }
        }
      }
      .el-upload__tip {
        margin-top: -15px;
        margin-bottom: 5px;
        color: #999;
        line-height: 1.4;
      }
    }
  }
  .form-item-complex {
    .el-row {
      width: 100% !important;
    }
    ::v-deep .el-input-number {
      .el-input-number__increase,
      .el-input-number__decrease {
        width: 20px;
        border-radius: 4px 0 0 4px;
      }
      .el-input {
        width: 100%;
        .el-input__inner {
          padding-right: 30px;
          border-radius: 4px 0 0 4px;
        }
      }
    }
    .el-button {
      font-size: 12px;
      border: 1px solid #dcdfe6;
      background-color: #f5f5f5;
      border-radius: 0 4px 4px 0;
      border-left: none;
      cursor: default;

      &:hover,
      &:active,
      &:focus {
        border-color: #dcdfe6;
        color: #333;
      }
    }
  }
  .el-button {
    & + .el-button {
      margin-left: 10px;
    }
  }
}
.mg_t_10 {
  margin-top: 10px;
  position: relative;
}
.crm-color-name {
  position: absolute;
  margin-left: 10px;
  font-size: 14px;
}

.radio-group-skin.el-radio-group {
  .el-radio {
    margin-right: 0;
    ::v-deep &.is-checked {
      .el-radio__inner:after {
        content: "";
        position: absolute;
        top: 4px;
        left: 10px;
        width: 10px;
        height: 18px;
        border-radius: 0;
        background-color: transparent;
        border-color: #fff;
        border-style: solid;
        border-width: 0 2px 3px 0;
        transform: rotate(45deg);
      }
    }
    &.blue {
      ::v-deep .el-radio__input {
        .el-radio__inner,
        .el-radio__inner:after {
          background-color: #2db7f5;
        }
      }
    }
    &.green {
      ::v-deep .el-radio__input {
        .el-radio__inner,
        .el-radio__inner:after {
          background-color: #67c23a;
        }
      }
    }
    &.pink {
      ::v-deep .el-radio__input {
        .el-radio__inner,
        .el-radio__inner:after {
          background-color: #f56c6c;
        }
      }
    }
    &.yellow {
      ::v-deep .el-radio__input {
        .el-radio__inner,
        .el-radio__inner:after {
          background-color: #ffa902;
        }
      }
    }
    &.skyblue {
      ::v-deep .el-radio__input {
        .el-radio__inner,
        .el-radio__inner:after {
          background-color: #00cccd;
        }
      }
    }
    &.lime {
      ::v-deep .el-radio__input {
        .el-radio__inner,
        .el-radio__inner:after {
          background-color: #aace06;
        }
      }
    }
    &.hotpink {
      ::v-deep .el-radio__input {
        .el-radio__inner,
        .el-radio__inner:after {
          background-color: #e03e74;
        }
      }
    }

    ::v-deep .el-radio__label {
      display: none;
    }
    ::v-deep .el-radio__input {
      margin-right: 10px;
      .el-radio__inner {
        display: inline-block;
        position: relative;
        border: 1px solid #dcdfe6;
        border-radius: 2px;
        box-sizing: border-box;
        width: 30px;
        height: 30px;
        border: none;
      }
    }
  }
}
.radio-border {
  ::v-deep &:after {
    content: "";
    display: block;
    border: 1px solid #fff;
    border-left: 0;
    border-top: 0;
    height: 16px;
    left: 4px;
    position: absolute;
    top: 1px;
    transform: rotate(45deg) scaleY(0);
    width: 16px;
  }
  ::v-deep .el-radio {
    &.is-bordered {
      margin-right: 8px;
      border-color: transparent;
      line-height: 0.8;
      border-radius: 0;
      padding: 2px;
      height: auto;
      & + .is-bordered {
        margin-left: 0;
      }
      .el-radio__label {
        padding-left: 0;
      }
      .el-radio__inner {
        background-color: transparent;
        border-color: transparent;
      }
    }
    &.is-checked {
      border-color: #337eff;

      .el-radio__inner {
        background-color: #337eff;
        &:after {
          content: "";
          position: absolute;
          top: 3px;
          left: 5px;
          width: 5px;
          height: 9px;
          border-radius: 0;
          background-color: transparent;
          border-color: #fff;
          border-style: solid;
          border-width: 0 1px 2px 0;
          transform: rotate(45deg);
        }
      }
    }
  }
  ::v-deep .el-radio__input {
    /*display: none;*/
    position: absolute;
    top: -6px;
    right: -6px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }
  &.is-checked {
    position: relative;
    ::v-deep &:after {
      background-color: #337eff;
      transform: rotate(45deg) scaleY(1);
    }
  }
}

.avatarImgCls {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
